const preloaderEl = document.getElementById("preloader");

let _done = 0;
let _removed = false;

export const preloader = {
  total: 0,
  onAppLoaded: null as (() => void) | null,

  complete(): void {
    _done++;
    updateProgress();
  },

  update(): void {
    if (_removed) return;
    if (_done >= this.total && this.onAppLoaded) {
      this.onAppLoaded();
      _removed = true;
      if (preloaderEl) {
        preloaderEl.style.opacity = "0";
        setTimeout(() => {
          preloaderEl.remove();
        }, 300);
      }
    }
  },
};

function updateProgress(): void {
  const pct = preloader.total > 0 ? Math.min(100, Math.round((_done / preloader.total) * 100)) : 0;
  const fill = document.querySelector(".progress-fill") as HTMLElement | null;
  if (fill) {
    fill.style.width = `${pct}%`;
  }
  const pctText = document.getElementById("loading-pct-text");
  if (pctText) {
    pctText.textContent = pct.toString();
  }
}
